import { Component, ElementRef, SimpleChange, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';

import { InteditRoutingModule } from './intedit.routing.module';

declare let $: any;
const errorMessage: any = {
  required: 'Ce champ est requis'
};

@Component({
  selector: 'intedit',
  template: `
  <div *ngIf="visible" class="md-form form-sm" [ngClass]="{'has-error':error}">
    <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value}" style="top: -0.3rem;"></i>
    <input type="number" id="{{name}}" (focus)="onFocus()" [ngStyle]="{'font-style': (readonly ? 'italic' :'') }" class="form-control inteditcomp mb-0" [formControl]="control" [attr.length]="length" [ngClass]="{'invalid':error}"
      style="text-align:right;" [readonly]="readonly"  #intedit/><!-- width: calc(100% - 3rem); -->
    <label for="{{name}}" [ngClass]="{'active':control.value}" [ngStyle]="{'top': (!control.value ? '.3rem' :'')}" style="text-align:left; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" ><em *ngIf="readonly">{{caption}}</em><b *ngIf="!readonly">{{caption}}</b> <span *ngIf="required && !control.value" style="color: red;"><b>*</b></span></label> 
    <!--<label *ngIf="caption" [attr.for]="name" [ngClass]="{'active':control.value != null}"><b>{{caption}}</b> <span *ngIf="required" style="color: red;"><b>*</b></span></label>-->
    <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '34px' :'')}" style="font-size: 15px"><b>{{ error }}</b></span>
  </div>`,
  styles: [`
  .inteditcomp {
      margin-bottom: 1.5rem;
      margin-top: 1rem;
  }

  .inteditcomp.ng-invalid {
      border-bottom: 1px solid #F44336;
      box-shadow: 0 1px 0 0 #F44336;
  }

  input[type=number]:focus:not([readonly]) {
      border-color: #007bff !important;
      box-shadow: 0 1px 0 0 #007bff !important;
  }`],
})

export class InteditComponent implements OnInit {
  @ViewChild('intedit') intedit: ElementRef;
  @Input() public name: string = '';
  @Input() public length: string = '0';
  @Input() public caption: string = '';
  @Input() public placeholder: string = '';
  @Input() public decimals: number = 0;
  @Input() public enabled: Boolean = false;
  @Input() public control: AbstractControl;
  @Input() public value: number;
  @Input() public glyph: string = '';
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Output() updated: EventEmitter<any> = new EventEmitter();
  @Input() public visible: boolean = true;
  @Input() public readonly: boolean = false;
  @Input() public required: boolean = false;
  public validators: ValidatorFn[] = new Array<ValidatorFn>();
  init: boolean = false;

  ngOnInit(): void {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    if (!this.init) {
      this.validators = new Array<ValidatorFn>();
      if (this.required) {
        this.validators.push(Validators.required);
      }
      this.control.setValidators(this.validators);
      this.placeholder = this.caption;
      this.control.valueChanges
        .subscribe((data) => {
          if (data) {
            if (this.countDecimals(data) > this.decimals) {
              this.control.patchValue(this.value);
            } else {
              this.value = data;
            }
          }
          this.returnError();
          this.updated.emit(data);
        });
      this.init = true;
    }
  }

  onFocus() {
    if (this.readonly) {
      $(this.intedit.nativeElement).blur();
    }
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (this.init) {
      this.validators = new Array<ValidatorFn>();
      if (changes.required && changes.required.currentValue) {
        this.validators.push(Validators.required);
      }
      this.control.setValidators(this.validators);
      this.control.updateValueAndValidity();
    }
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          this.error += errorMessage[key] + ' ';
        }
      }
    }
  }

  countDecimals(value: any) {
    if (Math.floor(value) === value) return 0;
    return value.toString().split('.')[1].length || 0;
  }
}
